import { createSlice } from '@reduxjs/toolkit';

// Define a type for the slice state
interface IUserActivityState {
    data: Array<IUserActivity> | null;
    pageSize: number;
    pageNumber: number;
    totalCount: number;
    showLoading: ILoading;
}

// Define the initial state using that type
const initialState: IUserActivityState = {
    data: null,
    pageSize: 0,
    pageNumber: 0,
    totalCount: 0,
    showLoading: {
        sourceAction: '',
        state: false,
    },
};

export const userActivitySlice = createSlice({
    name: 'userActivity',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            const { sourceAction, value } = action.payload;

            state.showLoading = {
                sourceAction: sourceAction,
                state: value,
            };
        },
        replaceItems: (state, action) => {
            const { data, pageSize, pageNumber, totalCount } = action.payload;
            state.data = data;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
        },
        resetLoading: (state, action) => {
            state.showLoading = {
                sourceAction: '',
                state: false,
            };
        },
    },
});

export const userActivityActions = userActivitySlice.actions;

export default userActivitySlice.reducer;
